import {useEffect, useState, useCallback, useReducer} from 'react';

import SearchWidgetUI from '../../../stories/components/hotels/common/SearchWidgetUI/SearchWidgetUI';
import useSearchWidget from '../../hooks/useSearchWidget';
import {useNavigateForSearchWidget} from '../../hooks/useNavigateForSearchWidget';
import usePrevious from '../../hooks/usePrevious'; // REFACTOR
import scrollToTop from '../../utils/scrollToTop';
import {pushga} from '@stencil/ga-utils';
import {gaConfig} from '@stencil/hotels-config';
import {useSelector, useDispatch} from 'react-redux';
import {
  selectedHotelSelector,
  isDateUpdatedForSEOSelector,
  isOpenCalendarOnDwebSelector,
  newCityIdSelectorFn,
  userCityPaxLengthSelector,
  locusSelector,
  requestQuerySelectorFn,
  mobConfigJSONSelectorFn,
  pokusCalendarPickerFn,
  isDateUpdatedForUnifSEOSelector,
} from '@stencil/hotels-common-reducer/src/selectors';
import {
  hotelDetailsSoldOut,
  staticApiRequestSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {
  isDatelessSeoSelector,
  srpSrpConfigDataSelector,
} from '@stencil/hotels-cg-reducer/src/srp/selectors';
import {updateSRPCgConfig, updateDatelessSeo} from '@stencil/hotels-cg-reducer/src/srp/actions';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  CommonPageComponents,
  SearchWidgetTrack,
} from '@stencil/omniture-analytics/src/constants/common';
import updateHotelGoSuggestParams from '@stencil/hotels-hooks/src/updateHotelGoSuggest';
import {
  getCmpCookieValue,
  getUserTimeZoneOffset,
  isObjectEmpty,
} from '@stencil/hotels-utils/src/common-utils';
import {setUserSearchInformationInLocalStorage} from '@stencil/hotels-utils/src/common-utils';
import useQuery from '@stencil/hotels-hooks/src/useQuery';
import {
  buildFilterCustomData,
  convertAppliedFiltertoStr,
} from '@stencil/use-filter/src/filterUtils';
import addDays from '@stencil/date-utils/src/addDays';

const {SrpGAEvents, detailsPageClickEventCategoryName, DetailsGAClickEventActions} = gaConfig;

const SearchWidget = ({
  isDetailsPage = false,
  isSrp = false,
  isSrpV2 = false,
  mode = '',
  isSem = false,
  openNewTabs = false,
  updateSearchClicked = () => {},
  setLinkUpdated = value => {},
  isSeoDetail = false,
  linkUpdated,
  forceReload = false,
  setParentCalMode = (mode?: string) => {},
  hotelId = '',
  callLandingandSearchApi = () => {},
  appliedFilters = {},
  appliedFiltersDispatch = () => {},
}) => {
  const {
    isRedirectTOSRPRequired,
    isDatePickRequired,
    checkin,
    checkout,
    destination,
    roomString,
    maxChildAge,
    autosuggestHandler,
    updateQueryCaller,
  } = useSearchWidget();
  const {allParams} = useQuery();

  const {onSearch} = useNavigateForSearchWidget();
  const {hotelPageGoSuggestHandler} = updateHotelGoSuggestParams();

  const {
    propertyName: selectedPropertyName,
    propertyId: selectedPropertyId,
    selected: hotelCardClicked,
  } = useSelector(selectedHotelSelector);

  const requestQuery = useSelector(requestQuerySelectorFn);
  const {isSeo: isSeoV2} = useSelector(srpSrpConfigDataSelector);
  const isDateUpdatedForSEO = useSelector(isDateUpdatedForSEOSelector);
  const isOpenCalendarOnDweb = useSelector(isOpenCalendarOnDwebSelector);
  const cityId = useSelector(newCityIdSelectorFn);
  const userCityPaxLength = useSelector(userCityPaxLengthSelector);
  const isSoldOutOnDetail = useSelector(hotelDetailsSoldOut);
  const isDateless = useSelector(isDatelessSeoSelector);
  const staticApiRequest = useSelector(staticApiRequestSelector);
  const locus = useSelector(locusSelector);
  const {multiRoomConfig = {}} = useSelector(mobConfigJSONSelectorFn);
  const isNewCalendarPicker = useSelector(pokusCalendarPickerFn);
  const isDateUpdatedForSEOUnif = useSelector(isDateUpdatedForUnifSEOSelector);

  const openSrpCgOnHotel = isSrp && !isObjectEmpty(locus);

  const cmpCookieValue = getCmpCookieValue();

  const isTimeZoneBehind = getUserTimeZoneOffset() || false;
  const dispatch = useDispatch();

  const isSeo = isSeoDetail || isSeoV2;

  const searchText = isSeo ? requestQuery?.searchText || '' : allParams?.searchText || '';

  /** to detect change in property */
  const prevSelectedPropertyId = usePrevious(selectedPropertyId);

  /** to detect change in city  */
  const prevDestinationId = usePrevious(destination?._id);
  /** current entity type */
  const currentEntityType = destination?.t;
  const searchInputValue = searchText || selectedPropertyName || destination?.n;
  const [searchWidgetInputState, setSearchWidgetInputState] = useState({
    selectedItem: isDetailsPage ? {t: 'hotel'} : {t: currentEntityType},
  });

  const {selectedItem} = searchWidgetInputState;

  // city or hotel
  const {t: inputSelectedValuePlaceType} = selectedItem;

  const prevInputSelectedValuePlaceType = usePrevious(inputSelectedValuePlaceType);

  let destinationChanged = false;

  /**
   * city was there before in the search input, city is searched again
   * so we need to check the destination id
   */
  if (inputSelectedValuePlaceType !== 'hotel') {
    destinationChanged =
      prevDestinationId && destination?._id && prevDestinationId !== destination?._id;
  }

  /**
   * property was there before in search input, property is search again
   * so we need to check selectedProperty in redux store
   */

  if (
    prevInputSelectedValuePlaceType === inputSelectedValuePlaceType &&
    inputSelectedValuePlaceType === 'hotel' &&
    !hotelCardClicked
  ) {
    destinationChanged =
      selectedPropertyId && prevSelectedPropertyId && prevSelectedPropertyId != selectedPropertyId;
  }

  /**
   * place type has surely changed
   */

  if (prevInputSelectedValuePlaceType !== inputSelectedValuePlaceType) {
    if (inputSelectedValuePlaceType === 'hotel') {
      destinationChanged = selectedPropertyId && prevDestinationId;
    }

    if (isDetailsPage && selectedItem && selectedItem?._id) {
      destinationChanged =
        destination?._id &&
        (prevSelectedPropertyId || ['city', 'region'].includes(prevInputSelectedValuePlaceType));
    }
  }

  const openInNewTab = (destinationChanged && isDetailsPage && !openNewTabs) || forceReload;

  const detailToSRPFlag =
    isDetailsPage &&
    (inputSelectedValuePlaceType === 'city' || inputSelectedValuePlaceType === 'region')
      ? true
      : false;

  const onSearchCaller = useCallback(
    ({
      isReplace = false,
      isResetOldFilter = false,
      isOpenSrpForHotelSearch = false,
      isDetailToSrpFlag = false,
      isDatePaxChange = false,
    }) => {
      if (openSrpCgOnHotel) {
        dispatch(
          updateSRPCgConfig({
            metaPartner: 'goSuggest',
          }),
        );
      }

      const customData = buildFilterCustomData(appliedFilters);

      onSearch({
        openInNewTab: openInNewTab,
        detailToSrpFlag: isDetailToSrpFlag,
        isSEMSearch: !isSrpV2 && isSem,
        openSRPForHotelSearch: isOpenSrpForHotelSearch,
        resetOldFilter: isResetOldFilter,
        isReplace: isReplace,
        isDatePaxChange: isDatePaxChange,
        customData,
      }); // clearing filters on destination change
    },
    [openInNewTab, detailToSRPFlag, openSrpCgOnHotel, appliedFilters],
  );

  useEffect(() => {
    if (destinationChanged) {
      if (linkUpdated) {
        setLinkUpdated(false);
        return;
      }
      onSearchCaller({
        isResetOldFilter: true,
        isOpenSrpForHotelSearch: openSrpCgOnHotel,
        isDetailToSrpFlag: detailToSRPFlag,
      });
    }
  }, [destinationChanged, onSearchCaller, linkUpdated, openSrpCgOnHotel]);

  useEffect(() => {
    if (isDateUpdatedForSEO && isSeoDetail && !staticApiRequest?.loading) {
      let eventLabel = 'default';
      if (isDateUpdatedForSEO && !isOpenCalendarOnDweb) {
        eventLabel = 'prefill';
      }

      if (isSeoDetail) {
        const isDatelessOnDweb = isSoldOutOnDetail && isOpenCalendarOnDweb && isSeoDetail;

        if (isDatelessOnDweb) {
          eventLabel = 'isDateless';
          dispatch(updateDatelessSeo(true));
        }
      }
      dispatch(
        detailsPagePushGaThunk({
          event: isDetailsPage ? detailsPageClickEventCategoryName : SrpGAEvents.hotelSrpClicks,
          eventCategory: isDetailsPage
            ? detailsPageClickEventCategoryName
            : SrpGAEvents.hotelSrpClicks,
          eventAction: DetailsGAClickEventActions.DatesExperimentName,
          eventLabel,
        }),
      );
    }
  }, [isDateUpdatedForSEO, staticApiRequest?.loading]);

  useEffect(() => {
    if (isTimeZoneBehind) {
      updateQueryCaller({
        checkin: {...checkin, date: addDays(checkin?.date, 1)},
        checkout: {...checkout, date: addDays(checkout?.date, 1)},
      });
    }
  }, []);

  const gaHandler = (
    type: 'location' | 'checkInCalendarClicked' | 'checkOutCalendarClicked' | 'pax',
    val,
    extraData: object = {},
  ) => {
    switch (type) {
      case 'location':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.locationChanged,
          eventLabel: val || '',
          ...extraData,
        });
        break;
      case 'checkInCalendarClicked':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.checkinCheckoutChanged,
          cdDaysToBooking: val,
          ...extraData,
        });
        break;
      case 'checkOutCalendarClicked':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.checkinCheckoutChanged,
          cdLOS: val,
          ...extraData,
        });
        break;

      case 'pax':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.roomGuestsChanged,
          cdHotelSearchRooms: val,
          ...extraData,
        });
        break;

      default:
        break;
    }
  };

  const searchWidgetOmniturePush = (name: string, val = '', extraData = {type: ''}) => {
    const omniCta = {
      cta: {
        name: `${name}${val ? `_${val}` : ''}`,
        type: omnitureConfig.ctaType.Button,
        componentName: CommonPageComponents.SearchWidget,
        destination: '',
      },
    };

    if (extraData?.type) {
      Object.assign(omniCta, {
        booking: {
          geoEntity: extraData?.type,
        },
      });
    }

    return dispatch(
      omnitureThunk(
        isDetailsPage ? omnitureConfig.pages.DetailsUnif : omnitureConfig.pages.SrpUnif,
        omnitureConfig.events.ctaClick,
        omniCta,
      ),
    );
  };

  const pushOmnitureTracking = (
    type: SearchWidgetTrack,
    val,
    extraData: {type: string} = {type: ''},
  ) => {
    switch (type) {
      case SearchWidgetTrack.Location: {
        searchWidgetOmniturePush('Location_Click', val, extraData);
        break;
      }
      case SearchWidgetTrack.CheckInCheckOut: {
        searchWidgetOmniturePush('Calendar_CheckOut_Click', val, extraData);
        if (isSem) {
          searchWidgetOmniturePush('sem_calendar_used');
        }
        break;
      }
      case SearchWidgetTrack.Pax: {
        searchWidgetOmniturePush('Pax_Clicked', val, extraData);
        break;
      }
      case SearchWidgetTrack.UpdateSearch: {
        searchWidgetOmniturePush('Update_Search_Clicked', val, extraData);
      }
      default:
        break;
    }
  };

  /**
   * Handles the click event for the auto suggest handler.
   * If the current page is SRP and the selected item is a hotel, it calls the hotelPageGoSuggestHandler and onSearch functions.
   * Otherwise, it calls the autosuggestHandler function.
   *
   * @param changes - The changes object containing the selected item.
   */
  const onAutoSuggestHandlerClickHandler = useCallback(
    changes => {
      if (
        destination?.t === changes?.selectedItem?.t &&
        destination?._id === changes?.selectedItem?._id
      ) {
        console.log('Same destination selected', changes?.selectedItem);
        return;
      }
      if (openSrpCgOnHotel) {
        autosuggestHandler(changes);
        dispatch(
          updateSRPCgConfig({
            metaPartner: 'goSuggest',
          }),
        );
        onSearch({
          openSRPForHotelSearch: openSrpCgOnHotel,
          // srpUnifVersion: srpUnifVersion,
          isReplace: true,
          resetOldFilter: true,
        });
      } else {
        autosuggestHandler(changes);
      }
    },
    [isSrp, openSrpCgOnHotel, destination?._id],
  );

  const handlUpdateSearch = useCallback(
    (isUpdateSearchButton = false) => {
      console.log('handlUpdateSearch', destinationChanged);
      let isDetailToSrpFlag = false;
      let openSRPForHotelSearch = false;
      if (isRedirectTOSRPRequired && hotelId) {
        dispatch(
          updateSRPCgConfig({
            metaPartner: 'goSuggest',
          }),
        );
        isDetailToSrpFlag = true;
        openSRPForHotelSearch = true;
      }
      setUserSearchInformationInLocalStorage(checkin, checkout, roomString);
      onSearchCaller({
        isOpenSrpForHotelSearch: openSRPForHotelSearch || openSrpCgOnHotel,
        isDetailToSrpFlag: detailToSRPFlag || isDetailToSrpFlag,
        isDatePaxChange: !isUpdateSearchButton || (isUpdateSearchButton && !destinationChanged),
      });
      scrollToTop();
      updateSearchClicked();
      if (isUpdateSearchButton) {
        pushOmnitureTracking(
          SearchWidgetTrack.UpdateSearch,
          `${searchInputValue}_${checkin?.date}_${checkout?.date}_${roomString}`,
          {type: selectedPropertyId ? 'hotel' : destination?.t},
        );
      }
    },
    [
      isRedirectTOSRPRequired,
      openInNewTab,
      detailToSRPFlag,
      isSem,
      searchInputValue,
      checkin,
      checkout,
      roomString,
      selectedPropertyId,
      destination,
      destinationChanged,
      appliedFilters,
    ],
  );

  return (
    <SearchWidgetUI
      updateQueryCaller={updateQueryCaller}
      autosuggestHandler={onAutoSuggestHandlerClickHandler}
      roomString={roomString}
      checkin={checkin}
      checkout={checkout}
      searchInputValue={searchInputValue}
      gaHandler={gaHandler}
      pushOmnitureTracking={pushOmnitureTracking}
      mode={mode}
      isSem={isSem}
      setParentCalMode={setParentCalMode}
      updateSearch={handlUpdateSearch}
      setSearchWidgetInputState={setSearchWidgetInputState}
      destinationChanged={destinationChanged && isSrp}
      isSeoDetail={isSeoDetail}
      isSeoSrp={isSeoV2}
      isOpenCalendarOnDweb={isOpenCalendarOnDweb}
      cityId={cityId}
      dispatch={dispatch}
      userCityPaxLength={userCityPaxLength}
      isDetail={isDetailsPage}
      isDateless={isDateless}
      updateDatelessSeo={updateDatelessSeo}
      maxChildAge={maxChildAge}
      isDatePickRequired={isDatePickRequired}
      callLandingandSearchApi={callLandingandSearchApi}
      multiRoomConfig={multiRoomConfig}
      appliedFiltersDispatch={appliedFiltersDispatch}
      appliedFiltersObj={appliedFilters}
      isNewCalendarPicker={isNewCalendarPicker}
      isSRPSEOV2={isSeoV2}
      isDateUpdatedForSEOUnif={isDateUpdatedForSEOUnif}
    />
  );
};

export default SearchWidget;
